import { Maybe } from 'graphql/jsutils/Maybe';

import {
  FeedPostComments,
  FeedPostFooter,
  FeedPostFooterContent,
  FeedPostFooterMetrics,
  FeedPostStatisticsBanner,
} from '../../../../../components/shared/FeedPost/FeedPost';
import {
  PostStatusEnum,
  TippingGoalFragment,
} from '../../../../../generated/feed';
import { useFeedPostStatistics } from '../../../../../provider/FeedPostStatisticsProvider';
import { usePostCommenting } from '../../../../../provider/PostCommentingProvider';
import { FeedPostTippingGoalSlot } from './FeedPostTippingGoalSlot/FeedPostTippingGoalSlot';
import { TempFeedPostScheduleProp } from './types';

export const PostFooter: React.FC<
  {
    postId: string;
    status: PostStatusEnum;
    likes: number;
    comments: number;
    tips: number;
    purchaseCount: number;
    price?: Maybe<number>;
    headline?: string | null;
    text?: string | null;
    tippingGoal: Maybe<TippingGoalFragment>;
    onClickOnLikes: (() => void) | undefined;
    onClickOnTips: (() => void) | undefined;
    borderRadius?: string;
  } & TempFeedPostScheduleProp
> = ({
  postId,
  status,
  likes,
  comments,
  tips,
  purchaseCount,
  headline,
  text,
  isPublished,
  price,
  publicationScheduledFor,
  borderRadius,
  tippingGoal,
  onClickOnLikes,
  onClickOnTips,
}) => {
  const feedPostStatisticsCtx = useFeedPostStatistics();
  const commentingCtx = usePostCommenting();

  const isScheduled =
    status === PostStatusEnum.Ok && !isPublished && !!publicationScheduledFor;
  const isCommentable = status !== PostStatusEnum.Broken && !isScheduled;
  const isMetricVisible = status !== PostStatusEnum.Broken && !isScheduled;
  const isStatisticBannerVisible =
    status !== PostStatusEnum.Broken && !isScheduled;

  return (
    <>
      {!isStatisticBannerVisible ? (
        <></>
      ) : (
        <FeedPostStatisticsBanner
          status={status}
          onClick={() => feedPostStatisticsCtx.action.showModal(postId)}
        />
      )}
      <FeedPostTippingGoalSlot tippingGoal={tippingGoal} />
      <FeedPostFooter borderRadius={borderRadius} w={'full'}>
        {(headline || text) && (
          <FeedPostFooterContent
            headline={headline}
            text={text}
            borderRadius={borderRadius}
          />
        )}
        {!isMetricVisible ? (
          <></>
        ) : (
          <FeedPostFooterMetrics
            likes={likes}
            comments={comments}
            tips={tips}
            isPaidContent={!!price}
            purchaseCount={purchaseCount}
            onClickOnLikes={onClickOnLikes}
            onClickOnComments={() => commentingCtx.action.showModal(postId)}
            onClickOnTips={onClickOnTips}
          />
        )}
        {!isCommentable ? (
          <></>
        ) : (
          <FeedPostComments
            commentCount={comments}
            onClickOnCommentButton={() =>
              commentingCtx.action.showModal(postId)
            }
          />
        )}
      </FeedPostFooter>
    </>
  );
};
